// an object with properties
export type Data = {
  [key: string]: any;
};

export type Action = {
  type: string;
  [key: string]: any;
};

// generic creator for action types
export const createAction =
  (type: string) =>
  (data: Data = {}): Action => ({
    type,
    ...data,
  });
